import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsModule } from '../../modules/material.module';
import { FormsModule } from '@angular/forms';
import { SearchBarComponent } from './search-bar.component';
import { DxSelectBoxModule, DxTextBoxModule } from 'devextreme-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonsModule } from '../buttons/buttons.module';

@NgModule({
  declarations: [SearchBarComponent],
  imports: [
    CommonModule,
    FormsModule,
    MaterialsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    TranslateModule,
    ButtonsModule,
  ],
  exports: [SearchBarComponent],
})
export class SearchBarModule {}
